module.exports = "<mat-calendar #picker (selectedChange)=\"addEvent($event)\" [dateClass]=\"dateClass\">\r\n</mat-calendar>"